import {pt2px} from '@/utils/converter'
import React from 'react'
import Image from 'next/image'
import 'yet-another-react-lightbox/styles.css'
import {useRouter} from 'next/router'
import next from 'next'

const formatImageUrl = (url: string | undefined) => {
  if (!url) return '/placeholder.png';
  
  // If it's already a full URL, return it
  if (url.startsWith('http')) return url;
  
  // Remove any leading slashes from the path
  const cleanPath = url.replace(/^\/+/, '');
  
  // Construct the CDN URL, ensuring no double slashes
  const cdnUrl = process.env.NEXT_PUBLIC_CDN_URL?.replace(/\/+$/, '') || '';
  return `${cdnUrl}/${cleanPath}`;
};

interface Props {
  pages: any
  pages_predefined_texts: any
  pages_dedication_texts: any
  product: any
  inputDedication: any
  cover_pages_predefined_texts: any
  cover_pages: any
  setStep?: any
  setActiveOption?: any,
  setDedicationModal?: any
}
export default function BookMobile({
  pages,
  pages_predefined_texts,
  product,
  pages_dedication_texts,
  inputDedication,
  cover_pages,
  cover_pages_predefined_texts,
  setStep,
  setActiveOption,
  setDedicationModal,
}: Props) {
  const modified_pages: any = []
  const [imageWidth, setImageWidth] = React.useState(0)
  const [open, setOpen] = React.useState(true)

  const router = useRouter()
  const isNotebookRoute = router.pathname.includes('notebook')
  const name =
    router.query.name != undefined ? (router.query.name as string) : ''
  const handleImageLoad = (event: any) => {
    const width = event.target.clientWidth
    setImageWidth(width)
  }
  const slides = [
    {
      type: 'custom-slide',
    },
  ]

  const [page, setPage] = React.useState(0)
  const [scrollPosition, setScrollPosition] = React.useState(0)

  const mobile_book_width =
    (document.getElementById('page-0')?.getBoundingClientRect().width ?? 0) + 25
  React.useEffect(() => {
    // Function to handle the scroll event on the 'mobile-book' div
    const handleScroll = () => {
      // Get the reference to the 'mobile-book' div
      const mobileBookDiv = document.getElementById('mobile-book')

      // Update the state with the current scrollLeft position of the 'mobile-book' div
      if (mobileBookDiv) {
        let new_page: number = Math.floor(
          mobileBookDiv.scrollLeft / mobile_book_width,
        )
        if (new_page != 0) {
          new_page *= -1
        }
        setPage(new_page)
        setScrollPosition(mobileBookDiv.scrollLeft)
      }
    }

    // Add event listener for the scroll event on the 'mobile-book' div
    const mobileBookDiv = document.getElementById('mobile-book')
    if (mobileBookDiv) {
      mobileBookDiv.addEventListener('scroll', handleScroll)
    }

    // Clean up the event listener when the component unmounts
    return () => {
      if (mobileBookDiv) {
        mobileBookDiv.removeEventListener('scroll', handleScroll)
      }
    }
  }, [mobile_book_width]) // Re-run if page width changes
  if (pages) {
    //Swap two elements
    for (let index = pages.length - 1; index >= 0; index--) {
      if ((index + 1) % 2 === 0) {
        continue
      }
      modified_pages.push(pages[index + 1], pages[index])
      slides.push(
        {type: 'custom-slide', ...pages[index + 1]},
        {type: 'custom-slide', ...pages[index]},
      )
    }

    //modified_pages.splice(modified_pages, 1)
    const getTextAlignment = (text_align: string) => {
      if (text_align == 'C') {
        return 'center'
      }
      if (text_align == 'R') {
        return 'right'
      }
      if (text_align == 'L') {
        return 'left'
      }
      return 'left'
    }
    return (
      <div className='w-full'>
        <div className="mobile-book" id="mobile-book">
          {/*
           *<Lightbox
           *  open={open}
           *  close={() => setOpen(false)}
           *  slides={slides}
           *  render={{
           *    slide: (slide: any) =>
           *      slide.type === 'custom-slide' ? (
           *        <BookMobileLightBoxSlide
           *          slide={slide}
           *          pages_predefined_texts={pages_predefined_texts}
           *          pages_dedication_texts={pages_dedication_texts}
           *          inputDedication={inputDedication}
           *          imageWidth={imageWidth}
           *        />
           *      ) : undefined,
           *  }}
           */}

          <div className="relative start-cover h-[50vh] lg:h-[80vh] w-full max-w-lg" id="page-0">
            {cover_pages_predefined_texts
              ?.filter((x: any) => x.page == '0')[0]
              ?.predefined_texts?.map((item: any, idx: number) => {
                let dimensions = JSON.parse(
                  cover_pages_predefined_texts.filter(
                    (x: any) => x.page == '0',
                  )[0]['dimensions'],
                )
                return (
                  <div
                    className={`texts absolute ${isNotebookRoute ? 'z-[10]' : 'z-[120]'}`}
                    key={idx}
                    id={item.X_coord_percent}
                    style={{
                      fontSize:
                        (imageWidth * item.font_size) /
                          pt2px(dimensions.width) <
                        10
                          ? 12
                          : (imageWidth * item.font_size) /
                            pt2px(dimensions.width),
                      textAlign: getTextAlignment(item.text_align),
                      width:
                        (imageWidth * item.max_width) / pt2px(dimensions.width),
                      top: item.Y_coord_percent + '%',
                      lineHeight: item.line_height,
                      whiteSpace: 'pre-wrap',
                      left: item.X_coord_percent * 2 + '%',
                      color: item.color,
                      fontFamily: item.font_face + ',sans-serif',
                    }}
                    dangerouslySetInnerHTML={{__html: item.text}}></div>
                )
              })}
            <div className={`w-[380px] h-[380px] lg:w-[500px] lg:h-[500px] ${isNotebookRoute ? 'z-[5]' : 'z-[110]'}`}>
              <Image
                alt="cover"
                className="object-cover border-[1.5px] border-primary rounded-md p-1"
                fill
                priority={true}
                onLoad={handleImageLoad}
                src={formatImageUrl(cover_pages[0])}
              />
            </div>
          </div>
          {modified_pages?.reverse().map((page: any, index: number) => {
            if (index == 0) {
              return <></>
            }
            return (
              <div className="relative h-[50vh] lg:h-[80vh] w-full max-w-lg" id={`page-${index}`} key={index}>
                <div className='relative w-full h-[380px] lg:w-[510px] lg:h-[500px]'>
                  <Image
                    alt="cover"
                    className={`block w-full mob-book-image img-${index} border-[1.5px] border-primary rounded-md p-1`}
                    fill
                    priority={true}
                    onLoad={handleImageLoad}
                    key={index}
                    src={formatImageUrl(page)}
                  />
                </div>
                {pages_dedication_texts
                  .filter((x: any) => x.page == index.toString())[0]
                  ?.dedication_texts?.map((item: any, idx: number) => {
                    let dimensions = JSON.parse(
                      pages_dedication_texts.filter(
                        (x: any) => x.page == index.toString(),
                      )[0]['dimensions'],
                    )
                    let book_img = document.querySelector('.mob-book-image')
                    if (item) {
                      return (
                        <div
                          className={`texts absolute ${(index === 1 && inputDedication == '') ? 'mt-10': ''}`}
                          key={idx}
                          style={{
                            fontSize:
                              (imageWidth * item.font_size) /
                                pt2px(dimensions.width) <
                              10
                                ? 12
                                : (imageWidth * item.font_size) /
                                  pt2px(dimensions.width),
                            width:
                              (imageWidth * item.max_width) /
                              pt2px(dimensions.width),
                            top: item.Y_coord_percent + '%',
                            whiteSpace: 'pre-wrap',
                            textAlign: getTextAlignment(item.text_align),
                            lineHeight: item.line_height,
                            color: item.color,
                            left: item.X_coord_percent + '%',
                            fontFamily: item.font_face + ',sans-serif',
                            direction: /^[a-zA-Z0-9\s.,!?;:'"\-()]*$/.test(inputDedication) ? 'ltr' : undefined,
                          }}>
                            {inputDedication.replace(
                              '{basmti}',
                              name ?? product.replace_name,
                            )}
                        </div>
                      )
                    } else {
                      return (
                        <></>
                      )
                    }
                  })}
                {pages_predefined_texts
                  .filter((x: any) => x.page == index.toString())[0]
                  ?.predefined_texts?.map((item: any, idx: number) => {
                    let dimensions = JSON.parse(
                      pages_predefined_texts.filter(
                        (x: any) => x.page == index.toString(),
                      )[0]['dimensions'],
                    )
                    let book_img = document.querySelector('.mob-book-image')
                    if (item) {
                      return (
                        <div
                          className="texts absolute"
                          key={idx}
                          style={{
                            //fontSize:
                            //(imageWidth * item.font_size) /
                            //pt2px(dimensions.width) <
                            //10
                            //? 12
                            //: (imageWidth * item.font_size) /
                            //pt2px(dimensions.width),

                            fontSize:
                              (imageWidth * item.font_size) /
                              pt2px(dimensions.width),
                            width:
                              (imageWidth * item.max_width) /
                              pt2px(dimensions.width),
                            top: item.Y_coord_percent + '%',
                            textAlign: getTextAlignment(item.text_align),
                            lineHeight: item.line_height,
                            whiteSpace: 'pre-wrap',
                            color: item.color,
                            left: item.X_coord_percent + '%',
                            fontFamily: item.font_face + ',sans-serif',
                          }}
                          dangerouslySetInnerHTML={{__html: item.text}}></div>
                      )
                    } else {
                      return <></>
                    }
                  })}
                  {(inputDedication === '' && index === 1) && (
                    <>
                    <button className='bg-primary-500 py-4 px-6 absolute -top-4 right-0 left-0 mx-auto rounded-lg max-w-[150px] flex lg:hidden items-center justify-center' onClick={()=>{
                      setStep('edit');
                      setActiveOption('dedication')
                    }}>
                      <p className='font-medium text-white text-base'>اكتب اهداء</p>
                    </button>
                    <button className='bg-primary-500 py-4 px-6 absolute -top-4 right-0 left-0 mx-auto rounded-lg max-w-[150px] hidden lg:flex items-center justify-center' onClick={()=>{
                      setDedicationModal(true);
                    }}>
                      <p className='font-medium text-white text-base'>اكتب اهداء</p>
                    </button>
                    </>
                  )}
              </div>
            )
          })}

          <div className="relative h-[50vh]" id={`page-${modified_pages.length + 1}`}>
            {cover_pages_predefined_texts
              ?.filter((x: any) => x.page == '1')[0]
              ?.predefined_texts?.map((item: any, idx: number) => {
                let dimensions = JSON.parse(
                  cover_pages_predefined_texts.filter(
                    (x: any) => x.page == '1',
                  )[0]['dimensions'],
                )
                return (
                  <div
                    className="texts absolute"
                    key={idx}
                    id={item.X_coord_percent}
                    style={{
                      fontSize:
                        (imageWidth * item.font_size) /
                          pt2px(dimensions.width) <
                        10
                          ? 12
                          : (imageWidth * item.font_size) /
                            pt2px(dimensions.width),
                      textAlign: getTextAlignment(item.text_align),
                      width:
                        (imageWidth * item.max_width) / pt2px(dimensions.width),
                      top: item.Y_coord_percent + '%',
                      lineHeight: item.line_height,
                      left: item.X_coord_percent * 2 + '%',
                      whiteSpace: 'pre-wrap',
                      color: item.color,
                      fontFamily: item.font_face + ',sans-serif',
                    }}
                    dangerouslySetInnerHTML={{__html: item.text}}></div>
                )
              })}
            <Image
              alt="cover"
              className="w-full h-full object-cover border-[1.5px] border-primary rounded-md p-1"
              width={350}
              height={350}
              priority={true}
              onLoad={handleImageLoad}
              src={formatImageUrl(cover_pages[1])}
            />
          </div>
        </div>
      </div>
    )
  }
  return <></>
}
